module.exports = __webpack_public_path__ + "img/horizontal_4_4_6005.e95c1629.png";